import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { useAuthStore } from '../../store/storeAuth';
import { AiTextGeneratorFormValues } from '../AiConfigs/constants';
import SliderField from './SliderField';

type Props = {
  watch: AiTextGeneratorFormValues;
  onChange: (e: any) => void;
  systems?: any[];
};

const Perplexity = ({ onChange, watch, systems }: Props) => {
  const { user } = useAuthStore(state => state);
  const isDark = user?.theme === 'dark';
  const perplexityModels =
    systems?.find((item: any) => item.system === 'perplexity')?.models || [];
  const selectSx = {
    '& .MuiList-root': {
      backgroundColor: isDark ? '#1D2939' : '#F9FAFB',
    },
    bgcolor: isDark ? '#1D2939' : '#F9FAFB',
    color: isDark ? '#D0D5DD' : '#101828',
    border: `2px solid ${isDark ? '#475467' : '#EAECF0'}`,
  };
  const menuProps = {
    PaperProps: {
      sx: {
        '& .Mui-selected': {
          backgroundColor: isDark ? '#667085' : '#D0D5DD',
        },
        backgroundColor: isDark ? '#1D2939' : '#F9FAFB',
      },
    },
  };
  return (
    <>
      <Box>
        <FormLabel sx={{ mb: '8px', mt: '8px', color: isDark ? '#D0D5DD' : 'black' }}>
          Model
        </FormLabel>
        <Select
          className="nodrag"
          value={watch.perplexityType}
          fullWidth
          size="small"
          onChange={onChange}
          name="perplexityType"
          sx={selectSx}
          MenuProps={menuProps}
        >
          {perplexityModels.map((opt: any) => (
            <MenuItem key={opt.id} value={opt.model} disabled={opt.disabledByCompany}>
              <Box display="flex" alignItems="center" gap="8px">
                <Typography variant="body2" color={isDark ? '#D0D5DD' : 'black'}>
                  {opt.model}
                </Typography>
                {opt.disabledByCompany && (
                  <Typography fontSize="12px" color="red">
                    (disabled by admin)
                  </Typography>
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box>
        <FormLabel sx={{ mb: '8px', mt: '8px', color: isDark ? '#D0D5DD' : 'black' }}>
          Search Context Size
        </FormLabel>
        <Select
          className="nodrag"
          value={watch.search_context_size}
          fullWidth
          size="small"
          onChange={onChange}
          name="search_context_size"
          sx={selectSx}
          MenuProps={menuProps}
        >
          <MenuItem value="low"><Typography>Low</Typography></MenuItem>
          <MenuItem value="medium"><Typography>Medium</Typography></MenuItem>
          <MenuItem value="high"><Typography>High</Typography></MenuItem>
        </Select>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: '20px',
        }}
      >
        <FormControlLabel
          control={
            <Switch
              onChange={() => {
                onChange({
                  target: { name: 'autoToken', value: !watch.autoToken },
                });
              }}
              name="autoToken"
              checked={watch.autoToken}
            />
          }
          label="Auto setting"
        />
        <FormControl>
          <TextField
            type="number"
            onChange={onChange}
            value={watch.autoToken ? 0 : watch.perplexityTokens}
            disabled={watch.autoToken}
            className="nodrag"
            label="Output Token Max"
            name="max_tokens"
            InputProps={{
              style: { color: isDark ? '#D0D5DD' : '#101828' },
            }}
            sx={{
              width: '290px',
              color: isDark ? '#D0D5DD' : '#101828',
              bgcolor: isDark ? '#1D2939' : '#F9FAFB',
              border: `2px solid ${isDark ? '#475467' : '#EAECF0'}`,
            }}
          />
        </FormControl>
      </Box>
      <SliderField
        label="Top P"
        name="perplexityTopP"
        value={Number(watch.perplexityTopP)}
        onChange={onChange}
        min={0}
        max={1}
        step={0.1}
      />
      <SliderField
        label="Temperature"
        name="perplexityTemperature"
        value={Number(watch.perplexityTemperature)}
        onChange={onChange}
        min={0}
        max={2}
        step={0.1}
      />
      <SliderField
        label="Top K"
        name="perplexityTopK"
        value={Number(watch.perplexityTopK)}
        onChange={onChange}
        min={0}
        max={40}
        step={1}
      />
    </>
  );
};

export default Perplexity;
